// import React, { useState } from "react";
// import axios from "axios";
// import { useHistory } from "react-router-dom";
// import { baseUrl } from "./baseUrl";

// function Login() {

//   const history = useHistory();

//   const [phone, setPhone] = useState("");
//   const [otp, setOtp] = useState("");
//   const [showOTP, setShowOTP] = useState(false);
//   const [message, setMessage] = useState("");

//   // SEND OTP
//   const sendOTP = async (e) => {
//     setOtp("")

//     if (e) e.preventDefault();

//     if (!phone) {
//       alert("Please enter phone number");
//       return;
//     }

//     try {

//       const response = await axios.post(
//         "https://www.supremetechnocom.com/backend/Apicontroller/Users/login",
//         new URLSearchParams({
//           phone: phone
//         }),
//         {
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded"
//           }
//         }
//       );

//       console.log("OTP API RESPONSE:", response.data);

//       setShowOTP(true);
//       setMessage("OTP Sent Successfully");

//       localStorage.setItem("supremetech_phone", phone);

//     } catch (error) {

//       console.log(error);
//       setMessage("Error sending OTP");

//     }

//   };


//   // VERIFY OTP
//   // const verifyOTP = async (e) => {
//   //   e.preventDefault();

//   //   // Use state directly as fallback
//   //   const savedPhone = localStorage.getItem("supremetech_phone") || phone;

//   //   if (!savedPhone) {
//   //     alert("Session expired. Please re-enter your phone number.");
//   //     setShowOTP(false);
//   //     return;
//   //   }

//   //   if (!otp) {
//   //     alert("Enter OTP");
//   //     return;
//   //   }

//   //   try {
//   //     const response = await axios.post(
//   //       "https://www.supremetechnocom.com/backend/Apicontroller/Users/register_otp_verify",
//   //       new URLSearchParams({
//   //         phone: savedPhone,
//   //         otp: otp
//   //       }),
//   //       {
//   //         headers: { "Content-Type": "application/x-www-form-urlencoded" }
//   //       }
//   //     );

//   //     console.log(response.data);

//   //     if (response.data.status === "success") {
//   //       localStorage.setItem("supremetech_token", response.data.token);
//   //       history.push("/dashboard");
//   //     } else {
//   //       setMessage(response.data.message || "Invalid OTP");
//   //     }

//   //   } catch (error) {
//   //     // Log full error details for debugging
//   //     console.log("Status:", error.response?.status);
//   //     console.log("Data:", error.response?.data);   // ← this will show the real server error
//   //     setMessage("OTP verification failed");
//   //   }
//   // };

//   const verifyOTP = async (e) => {
//     e.preventDefault();

//     const savedPhone = localStorage.getItem("supremetech_phone") || phone;

//     if (!savedPhone) {
//       alert("Session expired. Please re-enter your phone number.");
//       setShowOTP(false);
//       return;
//     }

//     if (!otp) {
//       alert("Enter OTP");
//       return;
//     }

//     try {

//       const formData = new FormData();
//       formData.append("otp", otp);
//       formData.append("phone", savedPhone);

//       const response = await axios.post(
//         baseUrl + "Users/register_otp_verify",
//         formData,
//         {
//           withCredentials: true
//         }
//       );

//       console.log("otp register:", response);

//       if (response.data?.status === "success") {
//         localStorage.setItem("supremetech_token", response.data.token);
//         history.push("/dashboard");
//       } else {
//         setMessage(response.data?.message || "Invalid OTP");
//       }

//     } catch (error) {
//       console.log("Full error:", error);
//       setMessage("OTP verification failed");
//     }
//   };
//   return (

//     <div style={{ maxWidth: "400px", margin: "auto", padding: "40px" }}>

//       <h2>Login</h2>

//       {message && <p>{message}</p>}

//       {!showOTP ? (

//         <form onSubmit={sendOTP}>

//           <input
//             type="text"
//             placeholder="Enter Phone Number"
//             value={phone}
//             onChange={(e) => setPhone(e.target.value)}
//             className="form-control"
//             required
//           />

//           <br />

//           <button type="submit" className="btn btn-dark w-100">
//             Send OTP
//           </button>

//         </form>

//       ) : (

//         <form onSubmit={verifyOTP}>

//           <input
//             type="text"
//             placeholder="Enter OTP"
//             value={otp}
//             maxLength="6"
//             onChange={(e) => setOtp(e.target.value)}
//             className="form-control"
//             required
//           />

//           <br />

//           <button type="submit" className="btn btn-dark w-100">
//             Verify OTP
//           </button>

//           <br />
//           <br />

//           {/* RESEND OTP BUTTON */}
//           <button
//             type="button"
//             onClick={sendOTP}
//             className="btn btn-secondary w-100"
//           >
//             Resend OTP
//           </button>

//         </form>

//       )}

//     </div>

//   );

// }

// export default Login;



import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

function Login() {

  const history = useHistory();

  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const loginUser = async (e) => {
    e.preventDefault();

    if (!phone) {
      alert("Please enter phone number");
      return;
    }

    try {

      const response = await axios.post(
        "https://www.supremetechnocom.com/backend/Apicontroller/Users/login",
        new URLSearchParams({
          phone: phone
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }
      );

     
      if (response.data.code === 200) {

        // Save user data
        localStorage.setItem(
          "supremetech_authentication",
          response.data.authentication
        );

        localStorage.setItem(
          "supremetech_phone",
          response.data.phone
        );

        localStorage.setItem(
          "supremetech_name",
          response.data.name
        );

        // Redirect to home
        // history.push("/");
        window.location.assign("/");

      } else {

        setMessage(response.data.message);

      }

    } catch (error) {

      console.log(error);
      setMessage("Login failed");

    }

  };

  return (

    <div style={{ maxWidth: "400px", margin: "auto", padding: "40px" }}>

      <h2>Login</h2>

      {message && <p style={{color:"red"}}>{message}</p>}

      <form onSubmit={loginUser}>

        <input
          type="text"
          placeholder="Enter Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="form-control"
          required
        />

        <br />

        <button type="submit" className="btn btn-dark w-100">
          Login
        </button>

      </form>

    </div>

  );

}

export default Login;